import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { ModalBranchInfoComponent } from 'src/app/components/modals/modal-branch-info/modal-branch-info.component';
import { Branch } from 'src/app/services/branch/branch.model';
import { BranchService } from 'src/app/services/branch/branch.service';
import { setAddressForGoogleMaps as setAddress } from 'src/app/helpers/google-maps-search.helper';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.scss'],
})
export class LoanComponent implements OnInit, OnDestroy {
  requiresNavbar = false;
  backTitle = '';
  backNavigation = '';
  selectedBranch: Branch | null = null;
  showInfoButton = false;
  setGoogleMapsSearch = setAddress;

  private subscriptions: Array<Subscription> = [];

  constructor(
    private router: Router,
    private navService: NavigationService,
    private branchService: BranchService,
    public config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    this.router.events.subscribe((item: Event) => {
      if (item instanceof NavigationEnd) {
        // Disables navigation when on starting page.
        this.requiresNavbar =
          item.url.includes('loan/') && !item.url.includes('confirmation');
      }
    });

    // Set global config for backdrop of modal so it doesn't close on a click event.
    config.backdrop = 'static';
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.navService.backNavTitle.subscribe((data: string) => {
        this.backTitle = data;
      })
    );

    this.subscriptions.push(
      this.navService.backNavUrl.subscribe((data: string) => {
        this.backNavigation = data;
      })
    );

    this.subscriptions.push(
      this.branchService.showInfoButton.subscribe((data: boolean) => {
        this.showInfoButton = data;
      })
    );

    this.subscriptions.push(
      this.branchService.selectedBranch.subscribe((data: Branch | null) => {
        this.selectedBranch = null;

        if (data) {
          this.selectedBranch = { ...data };
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  onBranchInfo() {
    if (this.selectedBranch) {
      this.modalService.open(ModalBranchInfoComponent);
    }
  }
}
